export const PRODUCTION_URL = 'https://api.pisciculturaglobal.com'
export const TEST_URL = 'http://127.0.0.1:8000'
export const BASE_URL = PRODUCTION_URL
export const BLOG_URL = 'https://www.pisciculturaglobal.com/'
export const AVATAR = 'https://pisci-bucket.us-nyc1.upcloudobjects.com/assets/avatar_male.png'
export const ICON = 'https://pisci-bucket.us-nyc1.upcloudobjects.com/assets/isologo.png'
export const LOGO = 'https://pisci-bucket.us-nyc1.upcloudobjects.com/assets/logo2.png?'
export const TW = 'https://twitter.com/PisciculturaG'
export const FB = 'https://www.facebook.com/pisciculturaglobal'
export const IN = '#'
export const NEWS_DEFAULT = 'piscicultura'
export const API = {
  google: '321566727742-6094f45i1h0dn2kvobqc8vjv2hk4rtm8.apps.googleusercontent.com',
  facebook: '1672818816360327',
  linkedin: '78c7jekdht13rc'
}



// WEBPACK FOOTER //
// ./src/config.js